import React from 'react'
import * as Bs from 'react-bootstrap'
import * as Bsr from 'react-router-bootstrap'
import Icon from './icon'

/**
 * Pagination component
 */
class Pagination extends React.Component {
  static propTypes = {
    list: React.PropTypes.object,
    route: React.PropTypes.string,
    query: React.PropTypes.object,
    search: React.PropTypes.string,
    offset: React.PropTypes.number,
    sort: React.PropTypes.string,
    dir: React.PropTypes.string,
    limit: React.PropTypes.number
  }

  static contextTypes = {
    router: React.PropTypes.func
  }

  render() {
    const { list, limit } = this.props
    const count = list.get('count')

    const offset = Number(this.props.offset) || 0

    let prev = offset !== 0 && offset - limit
    if (prev < 0) prev = 0

    const next = (offset + limit) < count && (offset + limit)
    const page = Math.floor(offset/limit) + 1
    const totalPage = Math.ceil(count/limit)

    return (
      <div>
        <Bs.ButtonGroup>
        <Bsr.ButtonLink
          className="hotkeys-prev"
          key={0}
          disabled={offset === 0}
          query={{
            ...this.props.query,
            offset: prev ? prev : undefined,
            sort: this.props.sort,
            dir: this.props.dir,
            search: this.props.search
          }}
          bsSize="small"
          to={this.props.route}>
            <Icon name="chevron-circle-left" /> Prev
        </Bsr.ButtonLink>
        <Bsr.ButtonLink
          className="hotkeys-next"
          key={1}
          disabled={!next}
          query={{
            ...this.props.query,
            offset: next,
            sort: this.props.sort,
            dir: this.props.dir,
            search: this.props.search
          }}
          bsStyle="primary"
          bsSize="small"
          to={this.props.route}>
            Next <Icon name="chevron-circle-right" />
        </Bsr.ButtonLink>
        </Bs.ButtonGroup>

        &nbsp;

        Page <b>{page}</b> of {totalPage} (<b>{count}</b> total records)
      </div>
    )
  }
}

export default Pagination



// WEBPACK FOOTER //
// ./modules/shared/components/pagination.js